module.exports = __webpack_public_path__ + "img/diamond-vid.16d2a8c5.gif";